import { render, staticRenderFns } from "./timeSwitch.vue?vue&type=template&id=2a8c5e9a&scoped=true&"
import script from "./timeSwitch.vue?vue&type=script&lang=js&"
export * from "./timeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./timeSwitch.vue?vue&type=style&index=0&id=2a8c5e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c5e9a",
  null
  
)

export default component.exports